import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles/theme";

export const Container = styled.div`
  position: fixed;
  inset-block-start: 0;
  inset-inline-start: 0;
  z-index: 3001;

  display: block;

  inline-size: 100%;
  block-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const Backdrop = styled.div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;

  inline-size: 100%;
  block-size: 100%;

  background-color: rgba(0, 0, 0, 0.5);
`;

export const Card = styled.div`
  position: absolute;
  inset-block-end: 0;

  padding-block: 16px;
  padding-inline: 20px 23px;

  background: #f6f6f6e6;
`;

export const CloseButton = styled.div`
  position: absolute;
  inset-block-start: 16px;
  inset-inline-end: 20px;

  cursor: pointer;
`;

export const Title = styled.div`
  margin-block-end: 7px;

  font-weight: 700;
  font-size: 16px;
  line-height: 18.75px;

  i {
    font-weight: 400;
    font-style: italic;
  }

  span {
    font-weight: 700;
  }
`;

export const Description = styled.div`
  margin-block-end: 17px;

  font-size: 14px;
  line-height: 18px;

  span {
    font-weight: 700;
  }
`;

export const StyledBaseLink = styled(BaseLink)`
  color: #4585ff;
  font-size: 14px;
  line-height: 16.41px;
`;
